if (document.querySelector('.copyLink')) {
    document.querySelector('.copyLink').addEventListener('click', () => {

        var copyText = document.querySelector('.copyLink').getAttribute('value');
    
        var textarea = document.createElement("textarea");
        textarea.textContent = copyText;
        textarea.style.position = "fixed"; // Prevent scrolling to bottom of page in MS Edge.
        document.body.appendChild(textarea);
        textarea.select();
        document.execCommand("copy"); 
        document.body.removeChild(textarea);
          
        document.execCommand("copy");  
    })
}